"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAT_NOTIFICATION_SETTING = void 0;
var CHAT_NOTIFICATION_SETTING;
(function (CHAT_NOTIFICATION_SETTING) {
    CHAT_NOTIFICATION_SETTING["ALL"] = "ALL";
    CHAT_NOTIFICATION_SETTING["IMPORTANT"] = "IMPORTANT";
    CHAT_NOTIFICATION_SETTING["NONE"] = "NONE";
})(CHAT_NOTIFICATION_SETTING || (exports.CHAT_NOTIFICATION_SETTING = CHAT_NOTIFICATION_SETTING = {}));
